module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-7816508df96382f5496a68ab86c387fd.png";